/**
 * Parse Google search result date strings (relative or absolute).
 * Matches backend job-indexer parseGoogleResultDate behavior.
 */
export function parseGoogleResultDate(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return null;

  const trimmed = dateStr.trim();
  if (!trimmed || trimmed.toLowerCase() === "n/a") return null;

  const relativeMatch = trimmed.match(
    /^(\d+)\s+(second|minute|hour|day|week|month|year)s?\s+ago$/i
  );
  if (relativeMatch) {
    const amount = parseInt(relativeMatch[1], 10);
    const unit = relativeMatch[2].toLowerCase();
    const msPerUnit = {
      second: 1000,
      minute: 60 * 1000,
      hour: 60 * 60 * 1000,
      day: 24 * 60 * 60 * 1000,
      week: 7 * 24 * 60 * 60 * 1000,
      month: 30 * 24 * 60 * 60 * 1000,
      year: 365 * 24 * 60 * 60 * 1000,
    };
    const offsetMs = amount * (msPerUnit[unit] || 0);
    return new Date(Date.now() - offsetMs);
  }

  if (/^yesterday$/i.test(trimmed)) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  }

  const parsed = Date.parse(trimmed);
  if (!Number.isNaN(parsed)) {
    return new Date(parsed);
  }

  return null;
}

export function formatLinkPostedDate(rawDate, getRelativeTimeString) {
  const parsed = parseGoogleResultDate(rawDate);
  if (parsed && getRelativeTimeString) {
    return getRelativeTimeString(parsed);
  }
  if (rawDate && String(rawDate).trim() && String(rawDate).toLowerCase() !== "n/a") {
    return String(rawDate).trim();
  }
  return null;
}
